import React from 'react'
import { useClaimant } from '../context/col'
import useAsync from '../hooks/useAsync'
import {
  PostCaseReportRespType,
} from '../models'
import { AxiosResponse } from 'axios'
import {
  CaseReportNextParams,
  postCaseReportNext,
} from '../services/case-report/postNext'
import ThankYouForm, {
  ThankYouDataType,
} from '../components/forms/ThankYouForm'

export type ThankYouPageProps = {
  transitions?: ThankYouPageTransitions
}

export type ThankYouPageTransitions = {
  goBack: () => void
  goToClaimantPage: () => void
}

const ThankYou = (props: ThankYouPageProps) => {
  const { state, dispatch } = useClaimant()
  const [thankYouPageData, setThankYouPageData] =
    React.useState<ThankYouDataType>({ policyNumber: '' })

  const { fetch: postCaseReportNext_andUpdateState } = useAsync({
    promiseFn: (params: any) => postCaseReportNext_internal(params),
  })

  function storeCaseReportPostResp(
    resp: PostCaseReportRespType,
    params?: CaseReportNextParams
  ) {
    localStorage.setItem('token', resp.token)
    dispatch({
      type: 'CaseReportCreated',
      payload: { postCaseReportResp: resp },
    })
  }
  const postCaseReportNext_internal = (value: CaseReportNextParams) => {
    return async () => {
      try {
        // AUTH == srvPostCaseReport
        const res: AxiosResponse<PostCaseReportRespType> =
          await postCaseReportNext(value)
        if (res.status >= 200 && res.status <= 202) {
          storeCaseReportPostResp(res.data, value)
          if (res?.status === 200) {
            props?.transitions?.goToClaimantPage()
          } else if (res?.status === 201) {
            props?.transitions?.goToClaimantPage()
          }
        } else {
          throw new Error(`Unknown response status: ${res.status}`)
        }
      } catch (error) {
        // console.log(error)
        if (error.response.status === 422) {
          dispatch({
            type: 'error',
            payload: { error: error.message },
          })
          throw error
        }
        if (error.response.status === 409) {
          dispatch({
            type: 'error',
            payload: { error: error.message },
          })
          throw error
        }
        dispatch({ type: 'error', payload: { error: error.message } })
        throw error
      }
    }
  }

  const handleThankYouPageSubmitted = (
    ThankYouDataParams: ThankYouDataType
  ) => {
    setThankYouPageData(ThankYouDataParams)

    const caseReportNext: CaseReportNextParams = {
      caseReportId: state.caseReportId!,
      nextCaseReportParams: {
        policyNumber: ThankYouDataParams.policyNumber,
      },
    }
    postCaseReportNext_andUpdateState(caseReportNext)
  }

  return (
    <ThankYouForm
      onPageContinue={handleThankYouPageSubmitted}
      data={thankYouPageData}
      errorMessage={''}
      isPageConfirmInProgress={false}
    />
  )
}

export default ThankYou
